import Continue from '../continue';
import ViewOrder from '../viewOrder';
import RequestContractResend from '../requestContractResend';
import RequestOrderReturn from '../requestOrderReturn';
import CancelOrder from '../cancelOrder';

const actions = {
  incomplete: [Continue, CancelOrder],
  pending: [CancelOrder],
  approved: [Continue, CancelOrder],
  pendingValidation: [ViewOrder, RequestOrderReturn, CancelOrder],
  waitingOnCredit: [ViewOrder, RequestOrderReturn, CancelOrder],
  waitingOnSales: [Continue, ViewOrder, CancelOrder],
  contractSent: [
    ViewOrder,
    RequestContractResend,
    RequestOrderReturn,
    CancelOrder
  ],
  contractSigned: [ViewOrder],
  contractExpired: [ViewOrder, CancelOrder],
  orderPlaced: [ViewOrder],
  orderCanceled: [ViewOrder],
  orderActivated: [ViewOrder],
  orderShipped: [ViewOrder],
  orderCompleted: [ViewOrder]
};

export default actions;
